"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmploymentStatusPriceOutputWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var components_1 = require("@athena-portal/components");
var commonFunctions_1 = require("../../../commonFunctions");
var EmploymentStatusPriceOutputWidget = /** @class */ (function (_super) {
    __extends(EmploymentStatusPriceOutputWidget, _super);
    function EmploymentStatusPriceOutputWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.paymentRequired = _this.props.interaction.factors.additionalPremium > 0;
        _this.refundRequired = _this.props.interaction.factors.returnPremium > 0;
        _this.state = {};
        return _this;
    }
    EmploymentStatusPriceOutputWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getPolicies().subscribe(function (policies) {
            _this.lookupService.fetchLookupValues("employmentStatus", "en-UK").subscribe(function (lookupValues) {
                _this.previousStatus = lookupValues.filter(function (item) { return item.id === policies[0].interaction.policyHolder.employmentStatus; })[0].value.toLowerCase();
                _this.newStatus = lookupValues.filter(function (item) { return item.id === _this.props.interaction.policyHolder.employmentStatus; })[0].value.toLowerCase();
                window.sessionStorage.removeItem("mtaEmploymentStatuses");
                window.sessionStorage.setItem("mtaEmploymentStatuses", JSON.stringify({ previousStatus: _this.previousStatus, newStatus: _this.newStatus }));
                _this.setState({ policies: policies, lookupValues: lookupValues });
            });
        });
        window.sessionStorage.removeItem("mtaEmploymentStatusAdditionalPremium");
        if (this.paymentRequired) {
            window.sessionStorage.setItem("mtaEmploymentStatusAdditionalPremium", this.props.interaction.factors.additionalPremium.toString());
        }
        window.sessionStorage.removeItem("mtaEmploymentStatusReturnPremium");
        if (this.refundRequired) {
            window.sessionStorage.setItem("mtaEmploymentStatusReturnPremium", this.props.interaction.factors.returnPremium.toString());
        }
    };
    EmploymentStatusPriceOutputWidget.prototype.render = function () {
        if (this.state.lookupValues && this.state.policies) {
            return ((0, jsx_runtime_1.jsxs)("div", { className: "_panel-dashboard form-group font-weight-extra-light text-center", children: [(0, jsx_runtime_1.jsxs)("div", { id: "price", className: "fs-24 letter-spacing-n35 font-weight-bold font-family-display mb-2", children: [this.paymentRequired && (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.additionalPremium) }), this.refundRequired && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, commonFunctions_1.getAmountToDisplay)(this.props.interaction.factors.returnPremium), " refund"] })] }), (0, jsx_runtime_1.jsxs)("div", { children: [this.paymentRequired && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["to change account holder's employment status from ", this.previousStatus, " to ", this.newStatus] }), this.refundRequired && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["you will get refund to change account holder's employment status from ", this.previousStatus, " to ", this.newStatus] }), !this.paymentRequired && !this.refundRequired && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["Great news! There is no extra cost to change account holder's employment status from ", this.previousStatus, " to ", this.newStatus] })] })] }));
        }
        else {
            return (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: true });
        }
    };
    __decorate([
        (0, core_1.lazyInject)(plugin_journey_1.Types.LookupService),
        __metadata("design:type", Object)
    ], EmploymentStatusPriceOutputWidget.prototype, "lookupService", void 0);
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], EmploymentStatusPriceOutputWidget.prototype, "customerPortalService", void 0);
    return EmploymentStatusPriceOutputWidget;
}(plugin_journey_1.WidgetBase));
exports.EmploymentStatusPriceOutputWidget = EmploymentStatusPriceOutputWidget;
//# sourceMappingURL=EmploymentStatusPriceOutputWidget.js.map